import stockItemsRoutes from "./modules/stock_items/routes"
import stockControlRoutes from "./modules/stock_control/routes"
import { stockTypesRoutes } from "./modules/stock_types/routes"

const routes = [
    ...stockItemsRoutes,
    ...stockControlRoutes,
    ...stockTypesRoutes
]

export default routes